
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { HeaderComponent } from 'src/app/shared/header/header.component';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AccessDeniedComponent implements OnInit {
  constructor() { }
  ngOnInit() {
  }

}
